








import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'user-management'
})
export default class UserManagement extends Vue {
}
